export const NON_CRITICAL_ERRORS: string[] = ['NG0100', 'NG0302'];
